import React, { useState } from "react";
import { MapPin, Phone, Mail, Clock, Send, CheckCircle } from "lucide-react";
import MapFormSection from "../../Components/Contact/MapFormSection";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      {/* Header Section */}
      <div className="w-full mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight">
            Get in Touch
          </h1>
          <p className="mt-5 max-w-xl mx-auto text-xl text-gray-500">
            Have questions or feedback? We'd love to hear from you. Our team is
            ready to assist.
          </p>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 border-t-4 border-blue-500">
            <div className="bg-blue-100 p-3 rounded-full mb-4">
              <MapPin className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Visit Us</h3>
            <p className="text-gray-600 text-center">Kalinga Bihar</p>
            <p className="text-gray-600 text-center">Bhubaneswar,Odisha</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 border-t-4 border-green-500">
            <div className="bg-green-100 p-3 rounded-full mb-4">
              <Phone className="h-6 w-6 text-green-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Call Us</h3>
            <p className="text-gray-600 text-center">+91(9777)772-782</p>
            <p className="text-gray-600 text-center">Mon-Sun, 9am-5pm</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 border-t-4 border-purple-500">
            <div className="bg-purple-100 p-3 rounded-full mb-4">
              <Mail className="h-6 w-6 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Email Us</h3>
            {/* <p className="text-gray-600 text-center">info@company.com</p> */}
            <p className="text-gray-600 text-center">bricknbar1@gmail.com</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 border-t-4 border-amber-500">
            <div className="bg-amber-100 p-3 rounded-full mb-4">
              <Clock className="h-6 w-6 text-amber-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Business Hours</h3>
            <p className="text-gray-600 text-center">Monday - Sunday</p>
            <p className="text-gray-600 text-center">9:00 AM - 5:00 PM</p>
          </div>
        </div>

        {/* Main Content */}
        <MapFormSection />

        {/* FAQ Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
            Frequently Asked Questions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-7xl mx-auto">
            {[
              {
                question: "What payment methods do you accept?",
                answer:
                  "We accept all major credit/debit cards, UPI, Net Banking, and wallet payments like Paytm and PhonePe.",
              },
              {
                question: "How can I track my order?",
                answer:
                  "Once your order is shipped, You can track it from your profile under 'My Orders'.",
              },
              {
                question: "What is your return and refund policy?",
                answer:
                  "You can return items within 7 days of delivery. Once we receive the returned item, a refund will be initiated within 3–5 business days.",
              },
              {
                question: "Do you offer Cash on Delivery (COD)?",
                answer:
                  "Yes, COD is available for most products. You’ll see the option at checkout if eligible for your pin code.",
              },
              {
                question: "How long does delivery take?",
                answer:
                  "Delivery usually takes 3–7 business days depending on your location. Express shipping is available at an additional cost.",
              },
              {
                question: "Can I modify or cancel my order after placing it?",
                answer:
                  "Orders can be modified or canceled within 1 hour of placing them. After that, they’re processed for shipping.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {faq.question}
                </h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
